import { render, staticRenderFns } from "./sh_bbj.vue?vue&type=template&id=efde4dbe&scoped=true&"
import script from "./sh_bbj.vue?vue&type=script&lang=js&"
export * from "./sh_bbj.vue?vue&type=script&lang=js&"
import style0 from "./sh_bbj.vue?vue&type=style&index=0&id=efde4dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efde4dbe",
  null
  
)

export default component.exports